import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import { StyledLink } from 'components/Common/MasterComponents'
import Icon from './Icon'
import Percent from './Percent'
import {
  formatBottleSize,
  getWineColorString,
  getWineSweetnessString,
  getWineTypeString,
} from 'utils/wine'
import { WINE_RATING_PATH } from 'utils/consts/path'

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 40px 1fr;
  grid-gap: 4px 16px;
`

const IconWrapper = styled(Link)`
  grid-row: span 2;
  align-self: flex-start;
`

const Text = styled.div`
  font: var(--typography-13-20-normal);
  color: #121432;
`

const ViewAllLink = styled(StyledLink)`
  font: var(--typography-13-20-normal);
`

const getColorForPercent = (percent: number) => {
  if (percent > 65) return '#00A042'
  if (percent < 35) return '#D00A00'
  return '#717284'
}

const RatingItem = ({ product, rating }) => {
  const { t } = useTranslation()
  const wine = product?.wine
  const percent = Math.round(rating?.rank ?? 0)
  const geoIndication = rating?.geoIndication?.localizedShortName ?? ''
  const count = rating?.count

  const specs = [
    geoIndication,
    getWineTypeString(wine),
    getWineColorString(wine),
    getWineSweetnessString(wine),
    formatBottleSize(product?.bottleSize?.volumeML),
  ]
    .filter(Boolean)
    .join(', ')

  const color = getColorForPercent(percent)

  // prettier-ignore
  const href = WINE_RATING_PATH
    .replace(':slug', product?.slug)
    .replace(':geoIndicationId', rating?.geoIndication?.id)

  return (
    <Wrapper>
      <IconWrapper to={href}>
        <Icon color={color} />
      </IconWrapper>
      <Text>
        <Trans
          t={t}
          i18nKey='wine.view.appellationRatings.text'
          components={[<Percent key='percent' color={color} />]}
          values={{ percent, specs }}
          tOptions={{ interpolation: { escapeValue: false } }}
        />
      </Text>
      <ViewAllLink to={href}>
        {t('wine.view.appellationRatings.viewAll') + ` (${count})`}
      </ViewAllLink>
    </Wrapper>
  )
}

export default RatingItem
